export default __webpack_public_path__ + "static/media/FiveWhys.50b4ae91a9592cfc26299f6d9d87e9e4.webp";